import { useQuery } from '@tanstack/react-query';
import { portalApi } from '../services/portalApi';
import { queryKeys } from './queryKeys';
import { useApiMutation } from '../hooks/useApiMutation';

export function useTeamPermissionsQuery({ enabled = true } = {}) {
  return useQuery({
    queryKey: queryKeys.users.permissions(),
    queryFn: portalApi.teamPermissions,
    staleTime: 10 * 60 * 1000,
    enabled
  });
}

export function useTeamQuery() {
  return useQuery({
    queryKey: queryKeys.users.list(),
    queryFn: portalApi.team,
    select: (res) => res.users || []
  });
}

const invalidate = [queryKeys.users.list(), queryKeys.scheduling.assignees()];

export function useInviteUserMutation() {
  return useApiMutation({ mutationFn: (payload) => portalApi.inviteUser(payload), invalidate, error: 'Could not add the team member' });
}

export function useUpdateUserMutation() {
  return useApiMutation({
    mutationFn: ({ id, ...changes }) => portalApi.updateUser(id, changes),
    invalidate,
    success: 'Team member updated',
    error: 'Could not update the team member'
  });
}

export function useResetUserPasswordMutation() {
  return useApiMutation({ mutationFn: (id) => portalApi.resetUserPassword(id), error: 'Could not reset the password' });
}

export function useRemoveUserMutation() {
  return useApiMutation({
    mutationFn: (id) => portalApi.removeUser(id),
    invalidate,
    success: 'Team member removed',
    error: 'Could not remove the team member'
  });
}
